import React from 'react';
import {
  View,
  Text,
  ScrollView,
  StyleSheet,
  Image,
} from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { useRouter } from 'expo-router';
import { useLanguage } from '@/contexts/LanguageContext';
import PrimaryButton from '@/components/PrimaryButton';
import { Svg, Path, Rect, ClipPath, Defs, G } from 'react-native-svg';

export default function OnboardingWelcomeScreen() {
  const router = useRouter();
  const { t } = useLanguage();
  const insets = useSafeAreaInsets();

  const handleProceed = () => {
    console.log('🚀 Proceeding to onboarding name (new pre-auth flow)');
    router.push('/onboarding-name');
  };

  // Feature cards data with real SVG icons
  const features = [
    {
      icon: <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M7.09447 3.27532C7.45356 2.50583 8.54774 2.50583 8.90683 3.27532L9.1992 3.90182C9.79522 5.179 10.8218 6.2056 12.099 6.80161L12.7255 7.09398C13.495 7.45307 13.495 8.54725 12.7255 8.90635L12.099 9.19872C10.8218 9.79473 9.79522 10.8213 9.19921 12.0985L8.90683 12.725C8.54774 13.4945 7.45356 13.4945 7.09447 12.725L6.8021 12.0985C6.20608 10.8213 5.17949 9.79473 3.90231 9.19872L3.27581 8.90635C2.50632 8.54725 2.50632 7.45307 3.27581 7.09398L3.90231 6.80161C5.17949 6.2056 6.20608 5.179 6.8021 3.90182L7.09447 3.27532Z" fill="#7E7D75"/>
      </Svg>,
      title: t('onboarding.welcome.features.bill'),
      description: t('onboarding.welcome.features.billDesc')
    },
    {
      icon: <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M12.6673 4.7915L6.25065 11.2082L3.33398 8.2915" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </Svg>,
      title: t('onboarding.welcome.features.diary'),
      description: t('onboarding.welcome.features.diaryDesc')
    },
    {
      icon: <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Defs>
          <ClipPath id="clip0_5633_20623">
            <Rect width="16" height="16" fill="white"/>
          </ClipPath>
        </Defs>
        <G clipPath="url(#clip0_5633_20623)">
          <Path fillRule="evenodd" clipRule="evenodd" d="M10.89 1.8335H5.11065C3.09665 1.8335 1.83398 3.2595 1.83398 5.2775V10.7228C1.83398 12.7408 3.08998 14.1668 5.11065 14.1668H10.8893C12.91 14.1668 14.1673 12.7408 14.1673 10.7228V5.2775C14.1673 3.2595 12.91 1.8335 10.89 1.8335Z" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M10.2607 9.34536L8 7.99669V5.08936" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </G>
      </Svg>,
      title: t('onboarding.welcome.features.clock'),
      description: t('onboarding.welcome.features.clockDesc')
    },
    {
      icon: <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Defs>
          <ClipPath id="clip0_5633_19727">
            <Rect width="16" height="16" fill="white"/>
          </ClipPath>
        </Defs>
        <G clipPath="url(#clip0_5633_19727)">
          <Path d="M8 1.3335V4.00016" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M8 12V14.6667" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M14.666 8H11.9993" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M4 8H1.33333" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M3.28516 3.28613L5.17077 5.17175" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M10.8281 10.8286L12.7137 12.7142" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M12.7148 3.28613L10.8292 5.17175" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <Path d="M5.17188 10.8286L3.28626 12.7142" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </G>
      </Svg>,
      title: t('onboarding.welcome.features.progress'),
      description: t('onboarding.welcome.features.progressDesc')
    },
    {
      icon: <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M11.5885 13.3794V3.84752C11.5885 3.16968 11.0384 2.61963 10.3605 2.61963H4.6693C3.99146 2.61963 3.44141 3.16968 3.44141 3.84752V13.3794" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <Path d="M8.96028 11.3475L8.96155 11.3819M8.96028 9.26025L8.96155 9.29465M6.00586 11.3475L6.00715 11.3819M6.00586 9.26025L6.00715 9.29465" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <Path d="M2.64648 13.3804H14.6465" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <Path d="M13.6545 13.38V6.19369C13.6545 5.68255 13.24 5.26807 12.7289 5.26807H11.5879" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <Path d="M7.51614 5.78632V6.82287M7.51614 5.78632V4.75M7.51614 5.78632H8.55267M6.47852 5.78632H7.51507" stroke="#7E7D75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </Svg>,
      title: t('onboarding.welcome.features.connection'),
      description: t('onboarding.welcome.features.connectionDesc')
    },
    {
      icon: <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path fillRule="evenodd" clipRule="evenodd" d="M7.99036 14.4042C7.99036 14.4042 13.105 12.8555 13.105 8.58616C13.105 4.31616 13.2904 3.98283 12.8804 3.57216C12.4697 3.1615 8.66103 1.8335 7.99036 1.8335C7.3197 1.8335 3.51103 3.1615 3.10103 3.57216C2.69036 3.98283 2.8757 4.31616 2.8757 8.58616C2.8757 12.8555 7.99036 14.4042 7.99036 14.4042Z" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <Path d="M6.25781 7.91675L7.51915 9.18008L10.1178 6.58008" stroke="#7E7D75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </Svg>,
      title: t('onboarding.welcome.features.privacy'),
      description: t('onboarding.welcome.features.privacyDesc')
    }
  ];

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.placeholder} />
        <View style={styles.titleContainer}>
          <Text style={styles.headerTitle}>{t('onboarding.header')}</Text>
        </View>
        <View style={styles.placeholder} />
      </View>
      
      <ScrollView 
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.content}>
          {/* Accomplishment Image */}
          <View style={styles.imageContainer}>
            <Image
              source={require('@/assets/images/accomplishment.png')}
              style={styles.accomplishmentImage}
              resizeMode="contain"
            />
          </View>

          {/* Welcome Text */}
          <View style={styles.textSection}>
            <Text style={styles.welcomeTitle}>
              {t('onboarding.welcome.title')}
            </Text>
            
            <Text style={styles.subtitle}>
              {t('onboarding.welcome.subtitle')}
            </Text>
          </View>

          {/* Features Card */}
          <View style={styles.featuresCard}>
            {features.map((feature, index) => (
              <View key={index} style={styles.featureItem}>
                <View style={styles.iconContainer}>
                  {feature.icon}
                </View>
                <View style={styles.featureContent}>
                  <Text style={styles.featureTitle}>{feature.title}</Text>
                  <Text style={styles.featureDescription}>{feature.description}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </ScrollView>

      {/* Fixed Bottom Button */}
      <View style={[styles.buttonContainer, { paddingBottom: insets.bottom + 24 }]}>
        <PrimaryButton
          title={t('onboarding.welcome.button')}
          onPress={handleProceed}
        />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9F8F3',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingVertical: 16,
    height: 56,
  },
  placeholder: {
    width: 24,
    height: 24,
  },
  titleContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    color: '#151515',
    textAlign: 'center',
    fontFamily: 'Inter_700Bold',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 16,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: 120, // Space for fixed button
  },
  content: {
    padding: 24,
    alignItems: 'center',
    gap: 24,
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8,
  },
  accomplishmentImage: {
    width: 280,
    height: 280,
  },
  textSection: {
    alignItems: 'center',
    gap: 16,
    width: '100%',
  },
  welcomeTitle: {
    color: '#151515',
    textAlign: 'center',
    fontSize: 24,
    lineHeight: 28.8,
    width: '100%',
    fontFamily: 'Sentient-Regular',
  },
  welcomeTitleRegular: {
    fontFamily: 'Sentient-Regular',
  },
  welcomeTitleItalic: {
    fontFamily: 'Sentient-Italic',
  },
  subtitle: {
    color: '#56554D',
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    fontWeight: '400',
    lineHeight: 19.6, // 140%
    width: '100%',
  },
  featuresCard: {
    padding: 24,
    alignItems: 'flex-start',
    gap: 24,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: '100%',
  },
  featureItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 24,
    width: '100%',
  },
  iconContainer: {
    backgroundColor: '#F0EEE4',
    borderRadius: 20,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  featureContent: {
    flex: 1,
    gap: 4,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  featureTitle: {
    color: '#151515',
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: '700',
    lineHeight: 19.6, // 140%
  },
  featureDescription: {
    color: '#151515',
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    fontWeight: '400',
    lineHeight: 19.6, // 140%
  },
  buttonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 24,
    paddingTop: 24,
    backgroundColor: '#F9F8F3',
    borderTopWidth: 1,
    borderTopColor: '#F0EEE4',
  },
});